import { createGlobalStyle } from "styled-components";
import { buildColorCssVars, buildCssVars } from "./cssVariables";
import {
  darkColorTokens,
  darkElevationTokens,
  lightColorTokens,
  lightElevationTokens,
  shapeTokens,
  typographyTokens,
} from "./tokens";

const lightVars = [
  buildColorCssVars(lightColorTokens),
  buildCssVars("elevation", lightElevationTokens as unknown as Record<string, unknown>),
].join("\n");
const darkVars = [
  buildColorCssVars(darkColorTokens),
  buildCssVars("elevation", darkElevationTokens as unknown as Record<string, unknown>),
].join("\n");
const shapeVars = buildCssVars("shape", shapeTokens as unknown as Record<string, unknown>);
const typographyVars = buildCssVars(
  "typography",
  typographyTokens as unknown as Record<string, unknown>,
);

export const GlobalStyle = createGlobalStyle`
  :root {
${shapeVars}
${typographyVars}
  }

  :root[data-c6-theme="light"] {
${lightVars}
  }

  :root[data-c6-theme="dark"] {
${darkVars}
  }
`;
